import { gql } from "@apollo/client";

export default gql`
  query getAskAIChatSessionHistoryQuery($after: String) {
    chatSessions(first: 20, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          created
          updated
          messages(first: 1, role: "user") {
            edges {
              node {
                id
                content
              }
            }
          }
        }
      }
    }
  }
`;
